import { Section } from '@shared/components/Section';
import { Ficha } from '@shared/components/moldes';
import { incluso } from '@curso/content/curso';

/**
 * O que está incluído.
 *
 * Virou ficha em 19/10, seguindo o roteiro: as quatro etapas da jornada em
 * vez de seis itens soltos. Existe porque some da cabeça de quem decide pela
 * equipe e reaparece como dúvida na hora de aprovar a despesa.
 */
export function Incluso() {
  return (
    <Section id="incluso" rotulo="Incluso" titulo="O que está incluso">
      <Ficha linhas={incluso} />
    </Section>
  );
}
